/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const heroSectionLandingConfig = {
  heroSectionId: '#home',
  heroHeading1: 'klefki',
  heroHeading2: '',
  heroDescription:
    'Create and share blockchain based Decentralized Identities and credentials',
  heroDarkButtonItem: {
    name: 'Explore',
    link: '/product/bharat-life-saral-jeevan-bima',
  },
  heroLightButtonItem: {
    name: 'Learn more',
    link: '#welcome',
  },
  heroBrand: {
    name: 'vlinder',
    logo: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/vlinder-logo.png',
    height: 40,
    width: 40,
    link: 'https://www.vlinder.io',
    footerText: 'Powered by vlinder',
  },
  heroWatermark: {
    name: 'klefki',
    image:
      'https://s3.ap-south-1.amazonaws.com/io.irdai.demo/bli-wallpaper-3.jpg',
    height: '500px',
    width: '1080px',
  },
};
